import { TranslateService } from '@ngx-translate/core';

import en from 'src/assets/i18n/en.json';
import no from 'src/assets/i18n/no.json';

export const registerLanguages = (translate: TranslateService) => {
  translate.setTranslation('en', en);
  translate.setTranslation('no', no);
  translate.setDefaultLang('en');
};
